<template>
  <div class="content-wrapper">
    <div class="m-4">

      <h3>Dashboard</h3>
    </div>
  </div>
</template>

<script>
import "../dist/js/pages/dashboard3.js";

import "../plugins/chart.js/Chart.min.js";
export default {
  name: "DashBoardCp"
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/DashBoardCp.vue